import { ReactComponent as CreditCard } from '../../assets/svgs/plan-creditcard.svg';
import { ReactComponent as Billet } from '../../assets/svgs/plan-billet.svg';
import { ReactComponent as PicPay } from '../../assets/svgs/plan-picpay.svg';

export const PJ = [
  { name: 'Cartão de Crédito', icon: CreditCard, key: 'creditCard'},
  { name: 'Boleto Bancário', icon: Billet, key: 'boleto',},
]

export const PF = [
  ...PJ,
]